<template>
  <div>
    <v-row class="mb-6">
      <v-col>
        <span class="sub-header1 bold grey--text">{{ $t('membership.headerContent') }}</span>
      </v-col>
    </v-row>
    <v-row class="mb-6">
      <template v-for="(item, index) of mode === 'about' ? serviceAbout:serviceTopic">
        <v-col :key="index" cols="12" md="5" class="my-6">
          <v-layout>
            <v-flex shrink mr-2>
              <v-img width="30" height="30" contain :src="item.icon"></v-img>
            </v-flex>
            <v-flex>
              <div class="sub-header2 text-tcdc-green bold mb-4">{{ item[`title_${lang}`] }}</div>
            </v-flex>
          </v-layout>
          <div class="vhtml mb-3" v-html="item[`content_${lang}`]"></div>
          <span class="text-tcdc-green readmore-link bold" v-if="item.slug && item.branch_id" @click="routeTo(item.slug, item.branch_id)">
            {{$t('service.readmore')}}
          </span>
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    props: {
      mode: {
        default: null
      }
    },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang,
      serviceAbout: state => {
        return [
          ...state.About.service_menu.map(service => ({
            branch_id: service.branch_id,
            title_th: service.title_th,
            title_en: service.title_en,
            icon: service.icon,
            slug: service.slug_url,
            content_th: service.description_th,
            content_en: service.description_en
          }))
        ]
      },
      serviceTopic: state => {
        return [
          ...state.ServiceMenu.service_menu.map(service => ({
            branch_id : service.branch_id,
            title_th : service.title_th,
            title_en : service.title_en,
            icon : service.icon,
            slug : service.slug_url,
            content_th : service.description_th,
            content_en : service.description_en
          }))
        ]
      }
    }),
  },
    methods: {
      async routeTo(url, branch_id) {
        if (url) {
          await this.$store.dispatch('Branch/getBranchById', branch_id);
          await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", {
            branch_id: branch_id,
            lang: this.lang
          });
          if (url[0] === '/') {
            this.$router.push(`/service${url}`);
          } else {
            this.$router.push(`/service/${url}`);
          }
        }
      }
    },
    created() {
    },
    data: () => ({
    serviceList: [
      {
        id: "999",
        title: "tcdc member",
        layout: "2"
      },
      {
        id: "998",
        title: "member rate",
        layout: "3"
      },
      {
        id: "997",
        title: "member benefit",
        layout: "4"
      }
    ],
    form: {
      title:
        "Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
      serviceTopic: [
        // {
        //   title: "MEMBERSHIP",
        //   content:
        //     "Lorem ipsum dolor sit amet, conse ctetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat."
        // },
        // {
        //   title: "RESOURCE CENTER",
        //   content:
        //     "Lorem ipsum dolor sit amet, conse ctetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat."
        // },
        // {
        //   title: "CONSULT",
        //   content:
        //     "Lorem ipsum dolor sit amet, conse ctetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat."
        // },
        // {
        //   title: "VENUE HIRE",
        //   content:
        //     "Lorem ipsum dolor sit amet, conse ctetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat."
        // },
        // {
        //   title: "VISIT & SERVICE AREA",
        //   content:
        //     "Lorem ipsum dolor sit amet, conse ctetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat."
        // }
      ]
    }
  })
};
</script>

<style lang="scss">
  .readmore-link:hover {
    border-bottom: solid 2px $tcdcGreen;
  }
  .readmore-link {
    cursor: pointer;
  }
</style>
